import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { defaultLayoutComponents } from '~/_v3/common/ui/components/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const CollectorsRoute: RouteRecordRaw = {
	name: RouteKeys.COLLECTORS,
	path: '/collectors',
	alias: '',
	components: {
		default: () => import('~/_v3/collectors/ui/pages/CollectorsPage.vue'),
		...defaultLayoutComponents
	},
	meta: {
		label: 'collectors.navigation',
		icon: () => $i('import'),
		order: 1,
		isNavEntry: true,
		requiresAuth: true
	}
};
